import { Repository } from "src/firebase/firestore/repository";
import { CreditVoucher } from "./types/credit-voucher.entity";

export class CreditVoucherRepository extends Repository<CreditVoucher> {
  constructor() {
    super("credit_vouchers");
  }
}

export const creditVoucherRepository = new CreditVoucherRepository();
